import { Auth0Service } from "@/src/app/shared/services/auth0.service";
import { UsersService } from "@/src/app/shared/services/rest-services/users.service";
import { environment } from "@/src/environments/environment.local_stage";
import { AuthMethod } from "@/src/environments/environment.model";
import { Injectable, Injector } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route, UrlSegment } from "@angular/router";
import { KeycloakAuthGuard, KeycloakService } from "keycloak-angular";
import { AuthService } from "../../ntx-core/auth/services/auth.service";

@Injectable({
    providedIn: 'root'
})
export class ReportsDemoGuardService extends KeycloakAuthGuard {
    constructor(
        private injector: Injector,
        readonly router: Router,
        protected readonly keycloak: KeycloakService,
        private auth0Service: Auth0Service,
        private readonly authService: AuthService,
        private readonly userService: UsersService,
    ) {
        super(router, keycloak);
    }

    async canMatch(route: Route, segments: UrlSegment[]): Promise<boolean | UrlTree> {
        const firstSegment = segments[0]?.path;

        if (firstSegment === 'auth') {
          return false;
        }
    
        if (environment.authMethod === AuthMethod.NONE) {
          return true;
        }
    
        switch (environment.authMethod) {
          case AuthMethod.AUTH_0:
            return this.auth0Authentication();
        }
    }

    /**
     * Check if the user is authenticate in both auth0 and netop logics
     * @param state
     */
    async auth0Authentication(): Promise<boolean | UrlTree> {
        const auth0Service = this.injector.get(Auth0Service);
        const isAuthenticated = await auth0Service.isAuthenticated();
    
        if (!isAuthenticated) {
          return this.router.parseUrl('/auth/login');
        }
    
        const user = await this.userService.authenticateUser();
        
        if (this.userService.userIsHaim) {
          this.authService.saveUserProfile({
            firstName: user.firstName,
            lastName: user.surname,
            email: user.email,
            username: `${user.firstName} ${user.surname}`,
          });
    
          return true;
        }
    
        return false;
      }

    async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Promise < boolean | UrlTree > {
        const isLoggedIn = await this.keycloak.isLoggedIn();

        if (isLoggedIn) {
            const userProfile = await this.keycloak.loadUserProfile();
            this.authService.saveUserProfile({
                firstName: userProfile.firstName,
                lastName: userProfile.lastName,
                email: userProfile.email,
                username: userProfile.username
            });
            // Get the roles required from the route.
            const requiredRoles = route.data.roles;

            // Allow the user to to proceed if no additional roles are required to access the route.
            if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
                return true;
            }

            // Allow the user to proceed if all the required roles are present.
            return requiredRoles.every((role) => this.roles.includes(role));
        } else {
            await this.keycloak.login({
                redirectUri: window.location.origin + state.url,
            });
        }
    }
}